import { types } from 'mobx-state-tree';

import Paths from '../types/Paths';
import generatePath from '../util/generatePath';
import ManufacturerIntegration from './ManufacturerIntegration';

const Manufacturer = types
  .model('Manufacturer', {
    id: types.identifier,
    name: types.string,
    slug: types.string,
    image: types.maybeNull(types.string),
    description_html: types.maybeNull(types.string),
    SEO_title: types.maybeNull(types.string),
    SEO_description: types.maybeNull(types.string),
    section_ids: types.array(types.integer),
    has_products: types.maybeNull(types.boolean),
    integrations: types.array(ManufacturerIntegration)
  })
  .views((self) => {
    return {
      get path() {
        return generatePath(Paths.Manufacturer, {
          slug: self.slug || self.name || self.id,
          id: self.id
        });
      },
      get breadcrumbs() {
        return [
          {
            text: self.name,
            url: self.path
          }
        ];
      },
      belongsToSection: (sectionId) =>
        self.section_ids.indexOf(sectionId) !== -1
    };
  });

export default Manufacturer;



// WEBPACK FOOTER //
// ./src/models/Manufacturer.js